import { Grid, TextField } from "@mui/material";

const DriverFilters = ({
  auxSearcher,
  setAuxSearcher,
}) => {
  return (
    <Grid item xs={12} md className="flex-left filters-container">
      <div className="row-container request-search-container">
        <Grid container>
          <TextField
            variant="outlined"
            label="Buscar"
            name="search"
            value={auxSearcher}
            onChange={(e) => {
              setAuxSearcher(e.target.value);
            }}
            className="mg-l-10"
            disabled={false}
          />
        </Grid>
      </div>
    </Grid>
  );
};

export default DriverFilters;
